<!-- eslint-disable -->
<template lang="pug">
    cs-loader(v-if="!params")
    .settings__form(v-else)
        .settings__field
            label.settings__label {{ "0-9" }}
        .settings-field
            .settings__field-body
                settings-tab.settings__button(
                    v-for="number in 9",
                    :selected="params.difficult.digits && !!params.difficult.digits[number - 1]",
                    :disabled="false",
                    @select="setDifficult('digits', number)",
                    :key="number",
                ) {{ number }}
        .settings-field
            .settings__field-body
                settings-tab.settings__button.settings__button_is-word-content(
                    v-for="difficult in difficulties",
                    :key="difficult.key",
                    :selected="params.difficult[difficult.key]",
                    @click.native="setDifficult(difficult.key, true)"
                ) {{ difficult.name }}
        .settings-field
            .settings__field-body
                | {{ $i18n.t('trainer.trainer_gameFormSetting_infiniteAmountOfExamples') }}:
                cs-checkbox.checkbox(
                    v-model="params.infinityAmountOfExamples",
                    :checked="params && params.infinityAmountOfExamples",
                    :disabled="params.isSeries",
                )
                span.help-text(v-if="params.isSeries") {{ $i18n.t('trainer.trainer_helpText_infiniteAmountOfExamplesWithSeries') }}
</template>

<script>
    /*eslint-disable*/
    export default {
        props: {
            currentUserParams: {
                type: Object,
                default () {
                    return null;
                }
            }
        },
        data () {
            return {
                params: null,
                digits: [1, 2, 3, 4, 5, 6, 7, 8, 9],
                difficulties: [
                    {
                        name: `${this.$i18n.t('trainer.trainer_gameFormSetting_tenners')} 10-90`,
                        key: 'tens',
                    },
                    {
                        name: `${this.$i18n.t('trainer.trainer_gameFormSetting_doubleDigits')} 10-19`,
                        key: 'teens',
                    },
                    {
                        name: `${this.$i18n.t('trainer.trainer_gameFormSetting_doubleDigits')} 10-99`,
                        key: 'twoDigit',
                    },
                    {
                        name: `${this.$i18n.t('trainer.trainer_gameFormSetting_tripleHundreds')} 100-900`,
                        key: 'hundreds',
                    },
                    {
                        name: `${this.$i18n.t('trainer.trainer_gameFormSetting_tripleDigits')} 100-999`,
                        key: 'threeDigit',
                    },
                    {
                        name: `${this.$i18n.t('trainer.trainer_gameFormSetting_fourThousands')} 1000-9000`,
                        key: 'thousands',
                    },
                    {
                        name: `${this.$i18n.t('trainer.trainer_gameFormSetting_fourDigits')} 1000-9999`,
                        key: 'fourDigit',
                    },
                    {
                        name: `${this.$i18n.t('trainer.trainer_gameFormSetting_fiveDigits')} 10000-99999`,
                        key: 'fiveDigit',
                    }
                ],
            }
        },
        watch: {
            currentUserParams: {
                handler (value) {
                    this.params = value;
                }
            },
            'params.difficult.digits': {
                handler (val) {
                    if (val && val.length === 0) {
                        this.params.difficult.digits = null;
                    }
                }
            },
        },
        methods: {
            setDifficult (key, value) {
                if (this.params.difficult[key] === value) {
                    this.params.difficult[key] = false;
                } else if (
                    this.params.difficult[key]
                    && this.params.difficult[key][this.params.difficult[key].length - 1] === value
                ) {
                    this.params.difficult[key] = this.params.difficult[key].slice(0, this.params.difficult[key].length - 1);
                } else {
                    Object.assign(this.params.difficult, {
                        teens: false,
                        twoDigit: false,
                        threeDigit: false,
                        fourDigit: false,
                        fiveDigit: false
                    });
                    if (key === 'digits') {
                        this.params.difficult.digits = this.digits.slice(0, value);
                    } else if (key !== 'tens' && key !== 'hundreds' && key !== 'thousands') {
                        this.params.difficult[key] = value;
                        this.params.difficult.digits = null;
                        this.params.difficult.tens = false;
                        this.params.difficult.hundreds = false;
                        this.params.difficult.thousands = false;
                    } else if (key === 'tens') {
                        this.params.difficult[key] = value;
                        this.params.difficult.hundreds = false;
                        this.params.difficult.thousands = false;
                    } else if (key === 'hundreds') {
                        this.params.difficult[key] = value;
                        this.params.difficult.tens = false;
                        this.params.difficult.thousands = false;
                    } else {
                        this.params.difficult[key] = value;
                        this.params.difficult.hundreds = false;
                        this.params.difficult.tens = false;
                    }
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .settings__form {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        padding: 25px 40px 15px;
        @include media($xl) {
            padding: 25px 40px;
        }
    }
    .settings__field {
        display: flex;
        justify-content: flex-start;
        @include stack-space($space-base);
    }
    .settings__label {
        display: flex;
        align-items: center;
        font-weight: 500;
        margin-right: 20px;
        white-space: nowrap;
    }
    .settings__field-body {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }
    .settings__button {
        margin-right: 10px;
    }
    .settings__button_is-word-content {
        margin-top: 10px;
    }
    .checkbox {
        margin: 10px;
    }
    .help-text {
        font-size: 14px;
        color: $hsl-color-gray-51;
    }
</style>